import React from 'react';
import { FallBackBtn } from '../../../components';

/**
 * GenerateReportFallback - Displayed when report hasn't been generated yet
 */
export const GenerateReportFallback = ({
    onGenerateReport,
    isLoading,
    disabled
}) => (
    <div className="fall-back-center-campaign">
        <FallBackBtn
            heading={"No Analytics Available"}
            title={"Please sync the data by clicking on Generate Report button if contracts are completed."}
            widthIcon={100}
            heightIcon={100}
            onClick={onGenerateReport}
            text={"Generate Report"}
            disabled={disabled}
            isLoading={isLoading}
        />
    </div>
);

/**
 * ReportInProgressFallback - Displayed when report is being generated
 */
export const ReportInProgressFallback = () => (
    <div className="fall-back-center-campaign">
        <FallBackBtn
            heading={"Generating Analytics Report"}
            title={"Please wait while we process your campaign data. This may take a few minutes."}
            widthIcon={100}
            heightIcon={100}
            text={""}
            isLoading={true}
        />
    </div>
);

/**
 * NoContractsFallback - Displayed when there are no completed contracts
 */
export const NoContractsFallback = () => (
    <div className="fall-back-center-campaign">
        <FallBackBtn
            heading={"No Completed Contracts"}
            title={"Once influencers complete their contracts, their analytics will show here."}
            widthIcon={100}
            heightIcon={100}
            text={""}
        />
    </div>
);
